import React from "react";
import { getToolIdFromTab } from "./toolRegistry";
import DrawToolPanel from "./draw/DrawToolPanel";
import PrintToolPanel from "./print/PrintToolPanel";
import MeasureToolPanel from "./measure/MeasureToolPanel";
import FilterToolPanel from "./filter/FilterToolPanel";
import AssetSearchToolPanel from "./assetSearch/AssetSearchToolPanel";
import QueryToolPanel from "./query/QueryToolPanel";
import SelectToolPanel from "./select/SelectToolPanel";
import BookmarkToolPanel from "./bookmark/BookmarkToolPanel";

const PANELS = {
  draw: DrawToolPanel,
  print: PrintToolPanel,
  measure: MeasureToolPanel,
  filter: FilterToolPanel,
  assetSearch: AssetSearchToolPanel,
  query: QueryToolPanel,
  select: SelectToolPanel,
  bookmark: BookmarkToolPanel,
};

export default function ToolDrawerPanels({ activeTab, activeTools, ctx }) {
  const toolId = getToolIdFromTab(activeTab, activeTools);
  if (!toolId) return null;

  const Panel = PANELS[toolId];
  return Panel ? <Panel {...ctx} /> : null;
}
